import { render, staticRenderFns } from "./diction_list.vue?vue&type=template&id=7863825c&scoped=true&"
import script from "./diction_list.vue?vue&type=script&lang=js&"
export * from "./diction_list.vue?vue&type=script&lang=js&"
import style0 from "./diction_list.vue?vue&type=style&index=0&id=7863825c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7863825c",
  null
  
)

export default component.exports